import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import './custom-title.scss';

type CustomTitleProps = {
  level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
};

function CustomTitle({
  className,
  level,
  ...props
}: ComponentProps<'h1'> & CustomTitleProps) {
  if (!level) return null;
  const Element = level as keyof React.JSX.IntrinsicElements;
  return (
    // @ts-ignore
    <Element
      data-slot="title"
      className={cn('custom-title', className)}
      {...props}
    />
  );
}

export { CustomTitle };
